import { Header } from '@/components/DashboardComponents'
import { useLoaderData } from 'react-router'
import { GenericEmptyListPlaceholder } from '@/DashboardLayout'
import { useMenu } from '@/components/Menu'
import { List, ListItem, ItemColumn } from '@/components/List'
import { useInmemoryStorage } from '@/hooks/useStorage'
import { shortDate } from '@/shared/utils'

export function InternalCourses() {
  const courses = useLoaderData().data.value;

  const [sort, setSort] = useInmemoryStorage("internal_courses_sort", ["date_created", -1]);

  return (
    <>
      <Header title="Courses"/>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <List fullPage={true} columns={[
          { name: "Course name", id: "name", sortable: [{ value: -1, name: "A to Z", arrow: "up", default: true }, { value: 1, name: "Z to A", arrow: "down" }] },
          { name: "Organization", id: "organization", width: 200, hide_order: 3, sortable: [{ value: -1, name: "A to Z", arrow: "up", default: true }, { value: 1, name: "Z to A", arrow: "down" }] },
          { name: "Educators", width: 200, hide_order: 2 },
          { name: "Date created", id: "date_created", width: 110, hide_order: 0, sortable: [{ value: -1, name: "New to old", arrow: "down", default: true }, { value: 1, name: "Old to new", arrow: "up" }] },
        ]} sort={sort} setSort={setSort} menu={true}>
          {[...courses].sort((a, b) => {
            if (sort[0] === "name") {
              const aName = (a.name || "").toLowerCase();
              const bName = (b.name || "").toLowerCase();
              return sort[1] === -1 ? aName.localeCompare(bName) : bName.localeCompare(aName);
            } else if (sort[0] === "organization") {
              const aOrg = (a._organization_name || "").toLowerCase();
              const bOrg = (b._organization_name || "").toLowerCase();
              if (!a._organization_name && !b._organization_name) return 0;
              if (!a._organization_name) return 1;
              if (!b._organization_name) return -1;
              return sort[1] === -1 ? aOrg.localeCompare(bOrg) : bOrg.localeCompare(aOrg);
            } else if (sort[0] === "date_created") {
              return sort[1] === -1 ? b.date_created - a.date_created : a.date_created - b.date_created;
            }
            return 0;
          }).map((course) => <CourseItem key={course._id} course={course}/>)}
        </List>
        {courses.length === 0 && <GenericEmptyListPlaceholder text="No courses"/>}
      </div>
    </>
  )
}

function CourseItem({ course }) {
  const menu = useMenu({
    menuItems: []
  });

  const educators = (course._educators || []).sort((a, b) => a.date_joined - b.date_joined);
  const first_educator_name = educators.length > 0 ? (educators[0].name || educators[0].email || "(Deleted user)") : null;
  const educator_display = first_educator_name
    ? (educators.length > 1 ? first_educator_name + " +" + (educators.length - 1) : first_educator_name)
    : "—";

  return (
    <ListItem icon="book-open-variant-outline" onClick={() => { window.open("https://app.sapientclinician.com/courses/" + course._id, "_blank") }}>
      <ItemColumn>{course.name}</ItemColumn>
      <ItemColumn>{course._organization_name || "—"}</ItemColumn>
      <ItemColumn>{educator_display}</ItemColumn>
      <ItemColumn>{course.date_created ? shortDate(course.date_created) : "—"}</ItemColumn>
    </ListItem>
  )
}
